import React from 'react'

const AboutUs = () => {
    return (
        <>
            <main className="flex-1">
                {/* Hero Section */}
                <section className="px-4 sm:px-6 lg:px-8 xl:px-40 flex justify-center py-8 sm:py-12 md:py-20">
                    <div className="layout-content-container flex flex-col max-w-[960px] flex-1">
                        <div className="@container">
                            <div className="@[480px]:p-0">
                                <div
                                    className="flex min-h-[300px] sm:min-h-[420px] flex-col gap-4 sm:gap-6 bg-cover bg-center bg-no-repeat @[480px]:gap-8 rounded-xl items-center justify-center p-6 sm:p-8 shadow-xl"
                                    data-alt="People studying together in a brightly lit modern library environment"
                                    style={{
                                        backgroundImage:
                                            'linear-gradient(rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%), url("/assets/about.png")'
                                    }}
                                >
                                    <div className="flex flex-col gap-4 text-center max-w-[700px]">
                                        <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl xl:text-6xl font-black leading-tight tracking-[-0.033em]">
                                            Empowering every learner through personalised tutoring
                                        </h1>
                                        <h2 className="text-white/90 text-sm sm:text-base lg:text-xl font-normal leading-relaxed">
                                            Our mission is to make high-quality tutoring accessible, transparent and trustworthy. Giving families the confidence to choose what’s right for them.
                                        </h2>
                                    </div>
                                    {/* <button className="flex min-w-[160px] cursor-pointer items-center justify-center rounded-lg h-12 px-6 bg-primary text-white text-base font-bold shadow-lg hover:bg-opacity-90 transition-all">
                                        Join Our Community
                                    </button> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Mission/Story Section */}
                <section className="bg-white dark:bg-white/5 py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 xl:px-40">
                    <div className="max-w-[960px] mx-auto flex flex-col items-center">
                        <h2 className="text-primary dark:text-[#f8fcfa] text-3xl font-bold leading-tight tracking-[-0.015em] mb-6">
                            Our Vision
                        </h2>
                        <p className="text-[#0d1b15] dark:text-[#f8fcfa]/80 text-lg font-normal leading-relaxed text-center max-w-[800px] mb-12">
                            Tutor Match AE is an app that was created to give families a clearer, more trusted way to find independent tutors.
                        </p>
                        <p className="text-[#0d1b15] dark:text-[#f8fcfa]/80 text-lg font-normal leading-relaxed text-center max-w-[800px] mb-12">
                            We believe children should be supported through learning that respects their individual pace, strengths, and needs.
                        </p>
                        <p className="text-[#0d1b15] dark:text-[#f8fcfa]/80 text-lg font-normal leading-relaxed text-center max-w-[800px] mb-12">
                            We believe parents should have the freedom to choose who supports their child’s learning, with transparency, quality, and trust at the heart of every decision.
                        </p>
                        <p className="text-[#0d1b15] dark:text-[#f8fcfa]/80 text-lg font-normal leading-relaxed text-center max-w-[800px] mb-12">
                            We believe independent tutors should be able to maintain their autonomy and earn fairly, while connecting with families to offer their services with confidence.
                        </p>

                    </div>
                </section>
                {/* Human Centric / Team Section */}

                {/* Values Section */}
                <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 xl:px-40 bg-white dark:bg-white/5">
                    <div className="max-w-[960px] mx-auto">
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 lg:gap-12">
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">
                                        diversity_3
                                    </span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Accessibility
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    High-quality tutoring should be easy to access, clear to navigate, and designed around real family needs.
                                </p>
                            </div>
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">security</span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Unwavering Trust
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    Trust sits at the heart of the platform, with identity and permit checks in place to support safe, transparent tutoring.
                                </p>
                            </div>
                            <div className="p-6 rounded-xl border border-[#e7f3ee] dark:border-white/10 bg-background-light/50 dark:bg-background-dark/50">
                                <div className="text-primary mb-4">
                                    <span className="material-symbols-outlined text-4xl">
                                        auto_awesome
                                    </span>
                                </div>
                                <h4 className="text-lg font-bold mb-2 dark:text-white">
                                    Human Connection
                                </h4>
                                <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                                    Meaningful learning is built through strong human connection, understanding, and supportive relationships.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                {/* Final CTA */}
                <section className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8 xl:px-40">
                    <div className="max-w-[960px] mx-auto text-center rounded-2xl bg-primary p-8 sm:p-12 shadow-2xl overflow-hidden relative">
                        {/* Subtle pattern background */}
                        <div
                            className="absolute inset-0 opacity-10"
                            style={{
                                backgroundImage: "radial-gradient(#fff 2px, transparent 2px)",
                                backgroundSize: "30px 30px"
                            }}
                        ></div>
                        <div className="relative z-10">
                            <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl font-black mb-4 sm:mb-6">
                                Ready to start your journey?
                            </h2>
                            <p className="text-white/80 text-base sm:text-lg mb-8 sm:mb-10 max-w-[600px] mx-auto">
                                Download the app and join Tutor Match AE today.
                            </p>
                            <div className="flex flex-col sm:flex-row justify-center gap-4 mt-6">
                                {/* Google Play */}
                                <a
                                    href="#"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-block"
                                >
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/Google_Play_Store_badge_EN.svg"}
                                        alt="Get it on Google Play"
                                        className="h-12 sm:h-14"
                                    />
                                </a>
                                {/* App Store */}
                                <a href="#" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src={process.env.PUBLIC_URL + "/assets/download-on-the-app-store.svg"}
                                        alt="Download on the App Store"
                                        className="h-12 sm:h-14"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    )
}

export default AboutUs